import { render, staticRenderFns } from "./DeliveryDuration.vue?vue&type=template&id=421b2ba6&lang=pug&"
import script from "./DeliveryDuration.vue?vue&type=script&lang=ts&"
export * from "./DeliveryDuration.vue?vue&type=script&lang=ts&"
import style0 from "./DeliveryDuration.vue?vue&type=style&index=0&id=421b2ba6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports